export default __webpack_public_path__ + "static/media/lip.a4002d34.PNG";